/**
 * Card Tokens
 */

import { bg, corners, space, border } from "../semantic";

export const card = {
  bg: bg.surface,
  bgHover: bg.surfaceHover,
  radius: corners.card,
  padding: space.insetMd,
  border: `0.5px solid ${border.default}`,
} as const;
